/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CarrierType } from '../model'
// @ts-ignore
import type { CarrierVisitDirection } from '../model'
// @ts-ignore
import type { DeleteAllocationRuleRequest } from '../model'
// @ts-ignore
import type { GetAllocationRulesResponse } from '../model'
// @ts-ignore
import type { UpsertAllocationRuleRequest } from '../model'
// @ts-ignore
import type { UpsertTemplateAllocationRuleRequest } from '../model'
/**
 * AllocationRulesApi - axios parameter creator
 */
export const AllocationRulesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {DeleteAllocationRuleRequest} [deleteAllocationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAllocationRule: async (
      deleteAllocationRuleRequest?: DeleteAllocationRuleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/AllocationRules/DeleteAllocationRule`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteAllocationRuleRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {boolean} isTemplate
     * @param {string} [id]
     * @param {CarrierVisitDirection} [direction]
     * @param {CarrierType} [carrierType]
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllocationRules: async (
      isTemplate: boolean,
      id?: string,
      direction?: CarrierVisitDirection,
      carrierType?: CarrierType,
      carrierVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'isTemplate' is not null or undefined
      assertParamExists('getAllocationRules', 'isTemplate', isTemplate)
      const localVarPath = `/yard/api/AllocationRules/AllocationRules`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (id !== undefined) {
        localVarQueryParameter['Id'] = id
      }

      if (isTemplate !== undefined) {
        localVarQueryParameter['IsTemplate'] = isTemplate
      }

      if (direction !== undefined) {
        localVarQueryParameter['Direction'] = direction
      }

      if (carrierType !== undefined) {
        localVarQueryParameter['CarrierType'] = carrierType
      }

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpsertAllocationRuleRequest} [upsertAllocationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertAllocationRule: async (
      upsertAllocationRuleRequest?: UpsertAllocationRuleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/AllocationRules/UpsertAllocationRule`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertAllocationRuleRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpsertTemplateAllocationRuleRequest} [upsertTemplateAllocationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertTemplateAllocationRule: async (
      upsertTemplateAllocationRuleRequest?: UpsertTemplateAllocationRuleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/AllocationRules/UpsertTemplateAllocationRule`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertTemplateAllocationRuleRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AllocationRulesApi - functional programming interface
 */
export const AllocationRulesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AllocationRulesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {DeleteAllocationRuleRequest} [deleteAllocationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteAllocationRule(
      deleteAllocationRuleRequest?: DeleteAllocationRuleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllocationRule(
        deleteAllocationRuleRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AllocationRulesApi.deleteAllocationRule']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {boolean} isTemplate
     * @param {string} [id]
     * @param {CarrierVisitDirection} [direction]
     * @param {CarrierType} [carrierType]
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAllocationRules(
      isTemplate: boolean,
      id?: string,
      direction?: CarrierVisitDirection,
      carrierType?: CarrierType,
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllocationRulesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAllocationRules(
        isTemplate,
        id,
        direction,
        carrierType,
        carrierVisitId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AllocationRulesApi.getAllocationRules']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpsertAllocationRuleRequest} [upsertAllocationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertAllocationRule(
      upsertAllocationRuleRequest?: UpsertAllocationRuleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.upsertAllocationRule(
        upsertAllocationRuleRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AllocationRulesApi.upsertAllocationRule']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpsertTemplateAllocationRuleRequest} [upsertTemplateAllocationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertTemplateAllocationRule(
      upsertTemplateAllocationRuleRequest?: UpsertTemplateAllocationRuleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.upsertTemplateAllocationRule(
        upsertTemplateAllocationRuleRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AllocationRulesApi.upsertTemplateAllocationRule']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AllocationRulesApi - factory interface
 */
export const AllocationRulesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AllocationRulesApiFp(configuration)
  return {
    /**
     *
     * @param {DeleteAllocationRuleRequest} [deleteAllocationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAllocationRule(
      deleteAllocationRuleRequest?: DeleteAllocationRuleRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteAllocationRule(deleteAllocationRuleRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {boolean} isTemplate
     * @param {string} [id]
     * @param {CarrierVisitDirection} [direction]
     * @param {CarrierType} [carrierType]
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllocationRules(
      isTemplate: boolean,
      id?: string,
      direction?: CarrierVisitDirection,
      carrierType?: CarrierType,
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetAllocationRulesResponse> {
      return localVarFp
        .getAllocationRules(isTemplate, id, direction, carrierType, carrierVisitId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpsertAllocationRuleRequest} [upsertAllocationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertAllocationRule(
      upsertAllocationRuleRequest?: UpsertAllocationRuleRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .upsertAllocationRule(upsertAllocationRuleRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpsertTemplateAllocationRuleRequest} [upsertTemplateAllocationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertTemplateAllocationRule(
      upsertTemplateAllocationRuleRequest?: UpsertTemplateAllocationRuleRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .upsertTemplateAllocationRule(upsertTemplateAllocationRuleRequest, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * AllocationRulesApi - object-oriented interface
 */
export class AllocationRulesApi extends BaseAPI {
  /**
   *
   * @param {DeleteAllocationRuleRequest} [deleteAllocationRuleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteAllocationRule(
    deleteAllocationRuleRequest?: DeleteAllocationRuleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AllocationRulesApiFp(this.configuration)
      .deleteAllocationRule(deleteAllocationRuleRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {boolean} isTemplate
   * @param {string} [id]
   * @param {CarrierVisitDirection} [direction]
   * @param {CarrierType} [carrierType]
   * @param {number} [carrierVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getAllocationRules(
    isTemplate: boolean,
    id?: string,
    direction?: CarrierVisitDirection,
    carrierType?: CarrierType,
    carrierVisitId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return AllocationRulesApiFp(this.configuration)
      .getAllocationRules(isTemplate, id, direction, carrierType, carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpsertAllocationRuleRequest} [upsertAllocationRuleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public upsertAllocationRule(
    upsertAllocationRuleRequest?: UpsertAllocationRuleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AllocationRulesApiFp(this.configuration)
      .upsertAllocationRule(upsertAllocationRuleRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpsertTemplateAllocationRuleRequest} [upsertTemplateAllocationRuleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public upsertTemplateAllocationRule(
    upsertTemplateAllocationRuleRequest?: UpsertTemplateAllocationRuleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AllocationRulesApiFp(this.configuration)
      .upsertTemplateAllocationRule(upsertTemplateAllocationRuleRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
